import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42f5a500"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pagination" };
const _hoisted_2 = { class: "pagination__page-sizes" };
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "pagination__btns" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pagination__arrows previous-arrow" }, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pagination__arrows next-arrow" }, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = { class: "pagination__go-to" };
const _hoisted_13 = ["value"];
import { computed, ref, watch } from 'vue';
var PaginationEvents;
(function (PaginationEvents) {
    PaginationEvents["UpdateCurrentPage"] = "update:currentPage";
    PaginationEvents["UpdatePageSize"] = "update:pageSize";
})(PaginationEvents || (PaginationEvents = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'TablePagination',
    props: {
        currentPage: {},
        currentPageSize: {},
        pageSizeOptions: {},
        total: {}
    },
    setup(__props, { emit: emits }) {
        const props = __props;
        const totalPages = computed(() => Math.ceil(props.total / props.currentPageSize));
        const localCurrentPage = ref(props.currentPage);
        const localPageSize = ref(props.currentPageSize);
        watch(() => props.currentPage, newVal => {
            localCurrentPage.value = newVal;
        });
        watch(() => props.currentPageSize, newVal => {
            localPageSize.value = newVal;
        });
        const pages = computed(() => {
            const total = totalPages.value;
            if (total <= 5) {
                return Array.from({ length: total }, (_currElement, idx) => idx + 1);
            }
            const firstPageNumber = 1;
            const current = props.currentPage;
            const numberOfPagesBeforeAndAfterCurrentPage = 2;
            // If there are more than 5 pages, we create "window" of 5 pages around the current page
            let start = Math.max(firstPageNumber, current - numberOfPagesBeforeAndAfterCurrentPage);
            let end = Math.min(total, current + numberOfPagesBeforeAndAfterCurrentPage);
            const visiblePages = 5;
            const windowSize = end - start + 1;
            if (windowSize < visiblePages) {
                const diff = visiblePages - windowSize;
                start = Math.max(1, start - diff);
                end = Math.min(total, start + visiblePages - 1);
            }
            const result = [];
            for (let i = start; i <= end; i++) {
                result.push(i);
            }
            return result;
        });
        function goToPage(page) {
            if (page < 1 || page > totalPages.value)
                return;
            emits(PaginationEvents.UpdateCurrentPage, page);
        }
        function onPageSizeChange() {
            emits(PaginationEvents.UpdatePageSize, localPageSize.value);
            const resetToPage = 1;
            emits(PaginationEvents.UpdateCurrentPage, resetToPage);
        }
        function onPageSelectChange() {
            goToPage(localCurrentPage.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('pagination.show')), 1),
                    _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localPageSize).value = $event)),
                        onChange: onPageSizeChange
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pageSizeOptions, (size) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: size,
                                value: size
                            }, _toDisplayString(size) + "/" + _toDisplayString(_ctx.$t('pagination.per-page')), 9, _hoisted_3));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, localPageSize.value]
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                        disabled: props.currentPage === 1,
                        onClick: _cache[1] || (_cache[1] = ($event) => (goToPage(props.currentPage - 1))),
                        class: "pagination__btn"
                    }, _hoisted_7, 8, _hoisted_5),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: page,
                            class: _normalizeClass(['pagination__btn', { active: page === props.currentPage }]),
                            onClick: ($event) => (goToPage(page))
                        }, _toDisplayString(page), 11, _hoisted_8));
                    }), 128)),
                    _createElementVNode("button", {
                        disabled: props.currentPage === totalPages.value,
                        onClick: _cache[2] || (_cache[2] = ($event) => (goToPage(props.currentPage + 1))),
                        class: "pagination__btn"
                    }, _hoisted_11, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('pagination.go-to-page')), 1),
                    _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localCurrentPage).value = $event)),
                        onChange: onPageSelectChange
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: page,
                                value: page
                            }, _toDisplayString(page), 9, _hoisted_13));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, localCurrentPage.value]
                    ])
                ])
            ]));
        };
    }
});
